/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureASquareUpIcon16Light = forwardRef('ArrowFigureASquareUpIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.5 11a.5.5 0 0 1-.5-.5V5.381l-1.616 1.94a.5.5 0 1 1-.768-.641l1.732-2.078a1.5 1.5 0 0 1 2.304 0l1.732 2.078a.5.5 0 0 1-.768.64L8 5.381V10.5a.5.5 0 0 1-.5.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 14a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H4Zm-2-3a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7Z" })));
});
